<template>
  <v-list-item>
    <v-list-item-avatar>
      <v-icon color="green darken-4">{{ icone }}</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title
        class="body-1 font-weight-bold green--text text--darken-4"
      >
        {{ titulo }}
      </v-list-item-title>
      <v-list-item-subtitle>
        <slot></slot>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  props: {
    icone: String,
    titulo: String,
  },
};
</script>

<style>
</style>